import { render } from "./TalkNowTalents.vue?vue&type=template&id=fc04cc8a&scoped=true&ts=true&lang=pug"
import script from "./TalkNowTalents.vue?vue&type=script&lang=ts"
export * from "./TalkNowTalents.vue?vue&type=script&lang=ts"

import "./TalkNowTalents.vue?vue&type=style&index=0&id=fc04cc8a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc04cc8a"]])

export default __exports__